"use client";

export type Platform = "ios" | "android" | "desktop" | "unknown";

export function detectPlatform(): Platform {
  if (typeof window === "undefined") return "unknown";
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return "ios";
  if (/android/.test(ua)) return "android";
  return "desktop";
}

export function isStandalone(): boolean {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  // iOS Safari proprietary flag
  const navStandalone = (window.navigator as unknown as { standalone?: boolean })
    .standalone;
  return navStandalone === true;
}

export function pushSupported(): boolean {
  if (typeof window === "undefined") return false;
  return (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

/**
 * iOS-only constraint: Web Push works only when the app is launched from the
 * Home Screen (PWA standalone mode). This returns true if the user is on iOS
 * but has NOT installed the app — push will not work for them yet.
 */
export function iosNeedsInstall(): boolean {
  return detectPlatform() === "ios" && !isStandalone();
}
